import axios from 'axios';

export const getGoogleUserInfo = async (accessToken: string) => {
  const response = await axios.get(
    `https://oauth2.googleapis.com/tokeninfo?id_token=${accessToken}`,
  );

  return response.data;
};
